import { useI18n } from "../../i18n";

/**
 * Bir abunəlik paketinin kartı — həm public qiymət səhifəsində,
 * həm də "Abunəliyim" ekranında istifadə olunur.
 */
const PlanCard = ({ plan, current = false, loading = false, onSelect, ctaLabel }) => {
  const { t, tr } = useI18n();

  const periodLabel = () => {
    if (plan.billing_period === "trial") {
      return t("sub.period_days", { count: plan.trial_days });
    }
    return plan.billing_period === "yearly"
      ? t("sub.period_year")
      : t("sub.period_month");
  };

  const priceLabel = () => {
    if (plan.is_free) return plan.is_trial ? t("sub.free_trial") : t("sub.free");
    return `${parseFloat(plan.price)} ${plan.currency}`;
  };

  const unlimited = t("common.unlimited");

  return (
    <div
      className={`relative bg-white rounded-3xl p-6 shadow-xl flex flex-col transition ${
        current ? "ring-4 ring-green-400" : "hover:-translate-y-1 hover:shadow-2xl"
      }`}
    >
      {current && (
        <span className="absolute -top-3 left-1/2 -translate-x-1/2 bg-green-500 text-white text-xs font-bold px-4 py-1 rounded-full shadow whitespace-nowrap">
          {t("sub.current_plan_badge")}
        </span>
      )}
      {plan.is_trial && !current && (
        <span className="absolute -top-3 left-1/2 -translate-x-1/2 bg-amber-400 text-white text-xs font-bold px-4 py-1 rounded-full shadow">
          {t("sub.trial_badge")}
        </span>
      )}

      <h3 className="text-xl font-extrabold text-gray-800">{tr(plan.name)}</h3>

      <div className="mt-3 mb-1 flex items-end gap-1">
        <span className="text-3xl font-extrabold text-indigo-600">
          {priceLabel()}
        </span>
        {!plan.is_free && (
          <span className="text-gray-400 font-medium mb-1">/ {periodLabel()}</span>
        )}
      </div>

      {plan.description && (
        <p className="text-sm text-gray-500 mt-1">{tr(plan.description)}</p>
      )}

      <ul className="mt-4 space-y-2 text-sm text-gray-700 flex-1">
        {(plan.features || []).map((f, i) => (
          <li key={i} className="flex items-start gap-2">
            <span className="text-green-500 font-bold">✓</span>
            <span>{tr(f)}</span>
          </li>
        ))}
        <li className="flex items-start gap-2">
          <span className="text-green-500 font-bold">✓</span>
          <span>
            {t("sub.feature_daily", {
              value: plan.max_quizzes_per_day ?? unlimited,
            })}
          </span>
        </li>
        <li className="flex items-start gap-2">
          <span className="text-green-500 font-bold">✓</span>
          <span>
            {t("sub.feature_monthly", {
              value: plan.max_coupons_per_month ?? unlimited,
            })}
          </span>
        </li>
      </ul>

      {onSelect && (
        <button
          onClick={() => onSelect(plan)}
          disabled={loading || current}
          className={`mt-6 w-full font-bold px-6 py-3 rounded-xl transition ${
            current
              ? "bg-gray-100 text-gray-400 cursor-default"
              : "bg-gradient-to-r from-indigo-500 to-fuchsia-600 text-white hover:scale-[1.02] shadow disabled:opacity-60 disabled:hover:scale-100"
          }`}
        >
          {current
            ? t("sub.is_active_label")
            : loading
            ? t("sub.wait")
            : ctaLabel || (plan.is_free ? t("sub.activate") : t("sub.subscribe"))}
        </button>
      )}
    </div>
  );
};

export default PlanCard;
